import React, { forwardRef } from 'react';
import { DatePicker } from 'antd';
import './stylemain.css'
import dayjs from "dayjs";
import TooltipButton from '../tooltip/Popover';

const DatePickerBox = forwardRef(({
  label,
  name,
  value,
  onChange,
  error = '',
  required = false,
  format = "D MMMM, YYYY",
  placeholder,
  fieldName,
  istrue,
  isextra,
}, ref) => {

  return (
    <div style={{ marginBottom:isextra? "6px" :  !istrue && 8, marginTop:isextra? "0px" : !istrue ? 8 :-8}}>
      <div>
        <label style={{display:'flex' , alignItems:"center", gap:"6px", fontWeight:500 , marginLeft:!istrue && "10px"}}>
         <span style={{color: (!value && error) ? 'red' :"black"}}> {label}</span> {required && <span style={{ color: 'red' }}> *</span>}
           {fieldName &&  <span style={{paddingLeft:"10px", display: 'flex', alignItems: 'center' }}>
        <TooltipButton fieldName={fieldName} />
      </span>}
        </label>

        <div style={{ flex: 1 }}>
          <div ref={ref}>
            <DatePicker
            className='datepic'
              value={value}
              onChange={(date) => onChange(name, date)}
              format={format}
              placeholder={placeholder}
              suffixIcon={null}
              allowClear={false}
               disabledDate={(current) =>
    current && current < dayjs().startOf("day")
  }
              style={{
                width: '100%',
                border: 'none',
                fontWeight:500,
                backgroundColor:isextra && "#f1f4f6",
                paddingLeft:(!isextra && istrue) && "0px",
                paddingTop:(!isextra && istrue) && "0px",
                padding:isextra && "10px 12px",
                paddingBottom :isextra && "8px",
        color:"black",
        borderRadius:isextra && "10px"
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
});

export default DatePickerBox;
